import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
export interface ILanguage {
  name: string;
  code: string;
  src: string;
  index: number;
}
@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  languages: Array<ILanguage> = [
    {
      name: 'Italiano',
      code: 'it',
      src: 'assets/images/flags/italy-flag.svg',
      index: 0,
    },
    {
      name: 'English',
      code: 'en',
      src: 'assets/images/flags/uk-flag.svg',
      index: 1,
    },
  ];
  public currentLanguage$: BehaviorSubject<ILanguage> =
    new BehaviorSubject<ILanguage>(this.languages[0]);

  constructor(private translate: TranslateService) {
    // const browselang = this.translate.getBrowserLang();
    // let selectedLanguage = this.languages.find(
    //   (lang) => lang.code === browselang
    // );
    // if (!selectedLanguage) {
    //   selectedLanguage = this.languages[0];
    // }
    // this.setLanguage(selectedLanguage);
  }

  public setLanguage(lang: ILanguage) {
    this.translate.use(lang.code);
    this.currentLanguage$.next(lang);
  }

  public getTranslationToastr(
    jsonPath: string,
    param?: string | number
  ): string {
    let text = '';
    this.translate.get([jsonPath], { param: param }).subscribe((trans) => {
      text = trans[jsonPath];
    });
    return text;
  }

  public getTranslationModal(jsonPathTitle: string, jsonPathText: string) {
    let [title, text] = '';
    this.translate.get([jsonPathTitle, jsonPathText]).subscribe((resp) => {
      title = resp[jsonPathTitle];
      text = resp[jsonPathText];
    });
    return { title, text };
  }
}
